










































































import {
  PropType,
  computed,
  defineComponent,
  ref,
} from "@nuxtjs/composition-api";
import { SfBadge } from "@storefront-ui/vue";
import { useCart, useImage } from "~/composables";
import type { CartItemInterface } from "~/modules/GraphQL/types";
import productGetters from "~/modules/catalog/product/getters/productGetters";
import SfPrice from "../../molecules/Product/SfPrice.vue";

export default defineComponent({
  name: "SfProductCardHorizontal",
  components: {
    SfPrice,
    SfBadge,
  },
  props: {
    cartItem: {
      type: Object as PropType<CartItemInterface>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { getMagentoImage } = useImage();
    const qty = ref(props.cartItem.quantity ?? 1);

    const productImage = computed(() =>
      getMagentoImage(
        productGetters.getProductThumbnailImage(props.cartItem.product)
      )
    );
    const productPrice = productGetters.getPrice(props.cartItem.product);
    const productName = computed(() =>
      productGetters.getName(props.cartItem.product)
    );
    const productLink = computed(() =>
      productGetters.getSlug(props.cartItem.product)
    );

    const { updateItemQty } = useCart();

    const updateCartQty = async () => {
      await updateItemQty({ product: props.cartItem, quantity: qty.value });
    };

    const increaseQty = () => {
      qty.value++;
      updateCartQty();
    };

    const decreaseQty = () => {
      if (qty.value > 1) {
        qty.value--;
        updateCartQty();
      }
    };

    const validateQty = () => {
      if (!qty.value) {
        qty.value = 1;
      }

      if (qty.value < 1) {
        qty.value = 1;
      }
      updateCartQty();
    };

    return {
      productImage,
      productName,
      qty,
      productGetters,
      increaseQty,
      decreaseQty,
      productLink,
      validateQty,
      productPrice,
    };
  },
});
